import React from "react";
import { Link } from "react-router-dom";
const Footer = () => {
  return (
    <footer className="footer footer-four pt-4">
      {/* Footer Top */}
      <div className="footer-top aos" data-aos="fade-up">
        <div className="container">
          <div className="row">
            {/* Footer Contact */}
       {/* <div className="col-lg-3">
  <div className="footer-contact footer-widget">
    <div className="footer-logo mb-3">
      <img src="/images/logo.jpg" className="img-fluid aos" alt="logo" />
    </div>

    <div className="footer-contact-info">
      <p className="text-white">
       Mumbai Airport Cab offers a reliable and comfortable airport transfer service with a wide range of vehicles including hatchbacks, sedans, SUVs, and luxury cars to suit every travel need. Whether it’s an airport pickup or drop at Chhatrapati Shivaji Maharaj International Airport, we ensure a smooth, punctual, and hassle-free journey
      </p>

      <p className="d-flex align-items-center mb-2">
        <i className="fas fa-phone-alt me-2" style={{ color: "#CE8304" }}></i>
        <a href="tel:+919545731161" style={{ color: "#fff", textDecoration: "none" }}>+91 9545731161</a>
      </p>
     
    
      <p className="d-fle align-items-start text-white">
        
        <h6><i className="fas fa-map-marker-alt me-2 mt-1 " style={{ color: "#CE8304" }}></i>Mumbai Airport Cabs</h6>
     
SAWANT SADAN 05 Ramachandra cold drinks House,
                  Near SBI Bank Nehru Road Opp Noble Medical,
                  Vile Parle East Mumbai-400057


      </p>
    </div>


<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2713.5809698580592!2d73.9129627!3d18.5619102!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c15a81afc021%3A0x1381bafdd2f10fca!2sLMS%20Finswell!5e1!3m2!1sen!2sin!4v1781103094445!5m2!1sen!2sin" width="100%" height="250" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>







    <li className="d-flex gap-3">
              <a href="https://www.instagram.com/mumbaiairportcab/" target="_blank" rel="noreferrer">
                <i className="fab fa-instagram text-white"></i>
              </a>

              <a href="https://www.facebook.com/profile.php?id=61591231475195" target="_blank" rel="noreferrer">
                <i className="fab fa-facebook-f text-white"></i>
              </a>

              <a href="https://x.com/mumbai_airport_" target="_blank" rel="noreferrer">
                <i className="fab fa-twitter text-white"></i>
              </a>

               <a href="https://in.pinterest.com/mumbaiairportcab/" target="_blank" rel="noreferrer">
                <i className="fab fa-pinterest-p text-white"></i>
              </a>
            </li>
  </div>
</div> */}

            {/* Footer Menus */}
            <div className="col-lg-12">
              <div className="row">
                <div className="col-lg-4 col-md-6">
                  <div className="footer-widget footer-menu">
                    <h5 className="footer-title">Our Services</h5>
                    <ul>
            
<li><Link to="/Mumbai-Outstation-Cabs"><i className="fas fa-plane-departure darkcolor"></i> Mumbai Outstation Cabs</Link></li>
<li><Link to="/Mumbai-to-Mahabaleshwar-Cab"><i className="fas fa-plane-departure darkcolor"></i> Mumbai to Mahabaleshwar Cab</Link></li>
<li><Link to="/Mumbai-to-Goa-Cabs"><i className="fas fa-plane-departure darkcolor"></i> Mumbai to Goa Cabs</Link></li>
<li><Link to="/Mumbai-to-Shirdi-Cab"><i className="fas fa-plane-departure darkcolor"></i> Mumbai to Shirdi Cab</Link></li>
<li><Link to="/Mumbai-Nashik-Cab"><i className="fas fa-plane-departure darkcolor"></i> Mumbai Nashik Cab</Link></li>
<li><Link to="/Mumbai-to-Kolhapur-Cab"><i className="fas fa-plane-departure darkcolor"></i> Mumbai to Kolhapur Cab</Link></li>
<li><Link to="/Mumbai-to-Pune-Cab"><i className="fas fa-plane-departure darkcolor"></i> Mumbai to Pune Cab</Link></li>
<li><Link to="/Mumbai-to-Aurangabad-Cab"><i className="fas fa-plane-departure darkcolor"></i> Mumbai to Aurangabad Cab</Link></li>
<li><Link to="/Mumbai-to-Bhimashankar-Cab"><i className="fas fa-plane-departure darkcolor"></i> Mumbai to Bhimashankar Cab</Link></li>
<li><Link to="/Mumbai-to-Ashtavinayak-Cab-Service"><i className="fas fa-plane-departure darkcolor"></i> Mumbai to Ashtavinayak Cab Service</Link></li>
<li><Link to="/Mumbai-to-5-Jyotirlinga-Cab"><i className="fas fa-plane-departure darkcolor"></i> Mumbai to 5 Jyotirlinga Cab</Link></li>
<li><Link to="/Mumbai-to-Lonavala-Cab"><i className="fas fa-plane-departure darkcolor"></i> Mumbai to Lonavala Cab</Link></li>
<li><Link to="/Mumbai-to-Konkan-Darshan-Cab-Booking"><i className="fas fa-plane-departure darkcolor"></i> Mumbai to Konkan Darshan Cab Booking</Link></li>
<li><Link to="/Mumbai-to-Alibaug-Cab"><i className="fas fa-plane-departure darkcolor"></i> Mumbai to Alibaug Cab</Link></li>
<li><Link to="/Mumbai-to-Ahmednagar-Cab"><i className="fas fa-plane-departure darkcolor"></i> Mumbai to Ahmednagar Cab</Link></li>
<li><Link to="/Mumbai-to-Matheran-Cab"><i className="fas fa-plane-departure darkcolor"></i> Mumbai to Matheran Cab</Link></li>
<li><Link to="/Mumbai-to-Jalgaon-Dhule-Cab-Booking"><i className="fas fa-plane-departure darkcolor"></i> Mumbai to Jalgaon Cab Booking / Dhule</Link></li>
<li><Link to="/Mumbai-to-Lavasa-Cab"><i className="fas fa-plane-departure darkcolor"></i> Mumbai to Lavasa Cab</Link></li>
<li><Link to="/Mumbai-to-Panchgani-Cab"><i className="fas fa-plane-departure darkcolor"></i> Mumbai to Panchgani Cab</Link></li>
<li><Link to="/Mumbai-to-Khandala-Taxi-Fare"><i className="fas fa-plane-departure darkcolor"></i> Mumbai to Khandala Taxi Fare</Link></li>
<li><Link to="/Mumbai-to-Surat-Cab"><i className="fas fa-plane-departure darkcolor"></i> Mumbai to Surat Cab</Link></li>
<li><Link to="/Mumbai-to-Ahmedabad-Cab"><i className="fas fa-plane-departure darkcolor"></i> Mumbai to Ahmedabad Cab</Link></li>
<li><Link to="/Mumbai-to-Narmada-Parikrama-Cab-Booking"><i className="fas fa-plane-departure darkcolor"></i> Mumbai to Narmada Parikrama Cab Booking</Link></li>
<li><Link to="/Mumbai-to-Baroda-Cabs"><i className="fas fa-plane-departure darkcolor"></i> Mumbai to Baroda Cabs</Link></li>
<li><Link to="/Mumbai-to-Daman-Taxi"><i className="fas fa-plane-departure darkcolor"></i> Mumbai to Daman Taxi</Link></li>
<li><Link to="/Mumbai-to-Vapi-Cab"><i className="fas fa-plane-departure darkcolor"></i> Mumbai to Vapi Cab</Link></li>
<li><Link to="/Mumbai-to-Bangalore-Cab"><i className="fas fa-plane-departure darkcolor"></i> Mumbai to Bangalore Cab</Link></li>
<li><Link to="/Mumbai-to-Indore-Cab"><i className="fas fa-plane-departure darkcolor"></i> Mumbai to Indore Cab</Link></li>
<li><Link to="/Mumbai-to-Jaipur-Taxi"><i className="fas fa-plane-departure darkcolor"></i> Mumbai to Jaipur Taxi</Link></li>
<li><Link to="/Mumbai-Airport-to-Pune-Cabs"><i className="fas fa-plane-departure darkcolor"></i> Mumbai Airport to Pune Cabs</Link></li>
<li><Link to="/Mumbai-to-Imagica-Cab"><i className="fas fa-plane-departure darkcolor"></i> Mumbai to Imagica Cab</Link></li>
<li><Link to="/Cab-Service-in-Mumbai"><i className="fas fa-plane-departure darkcolor"></i> Cab Service in Mumbai</Link></li>
<li><Link to="/Best-Taxi-Service-in-Mumbai"><i className="fas fa-plane-departure darkcolor"></i> Best Taxi Service in Mumbai</Link></li>
<li><Link to="/Online-Taxi-Booking-Mumbai"><i className="fas fa-plane-departure darkcolor"></i> Online Taxi Booking Mumbai</Link></li>
<li><Link to="/Mumbai-Darshan-Cabs"><i className="fas fa-plane-departure darkcolor"></i> Mumbai Darshan Cabs</Link></li>
<li><Link to="/Wedding-Car-Rental-Mumbai"><i className="fas fa-plane-departure darkcolor"></i> Wedding Car Rental Mumbai</Link></li>
<li><Link to="/One-Way-Cab-Service"><i className="fas fa-plane-departure darkcolor"></i> One Way Cab Service</Link></li>
<li><Link to="/Corporate-Cab-Services-in-Mumbai"><i className="fas fa-plane-departure darkcolor"></i> Corporate Cab Services in Mumbai</Link></li>

                   </ul>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="footer-widget footer-menu">
                    <h5 className="footer-title">Our Services</h5>
  <ul>
<li><Link to="/Cab-Companies-in-Mumbai"><i className="fas fa-plane-departure darkcolor"></i> Cab Companies in Mumbai</Link></li>
<li><Link to="/Mumbai-Car-Rental-Service"><i className="fas fa-plane-departure darkcolor"></i> Mumbai Car Rental Service</Link></li>
<li><Link to="/Round-Trip-Cab-Booking-Mumbai"><i className="fas fa-plane-departure darkcolor"></i> Round Trip Cab Booking Mumbai</Link></li> 
<li><Link to="/Cab-Service-in-Thane"><i className="fas fa-plane-departure darkcolor"></i> Cab Service in Thane</Link></li>
<li><Link to="/Cab-Service-Near-Me-Mumbai"><i className="fas fa-plane-departure darkcolor"></i> Cab Service Near Me Mumbai</Link></li>
<li><Link to="/Swift-Dzire-on-Rent-in-Mumbai"><i className="fas fa-plane-departure darkcolor"></i> Swift Dzire on Rent in Mumbai</Link></li>
<li><Link to="/Cab-Service-in-Navi-Mumbai"><i className="fas fa-plane-departure darkcolor"></i> Cab Service in Navi Mumbai</Link></li>
<li><Link to="/Taxi-Service-at-Mumbai-International-Airport"><i className="fas fa-plane-departure darkcolor"></i> Taxi Service at Mumbai International Airport</Link></li>
<li><Link to="/Cab-Service-in-Kalyan"><i className="fas fa-plane-departure darkcolor"></i> Cab Service in Kalyan</Link></li>
{/* <li><Link to="/Cab-Service-in-Dombivli"><i className="fas fa-plane-departure darkcolor"></i> Cab Service in Dombivli</Link></li> */}
<li><Link to="/Innova-Car-Rental-Mumbai"><i className="fas fa-plane-departure darkcolor"></i> Innova Car Rental Mumbai</Link></li>
<li><Link to="/Innova-Crysta-on-Rent-in-Mumbai"><i className="fas fa-plane-departure darkcolor"></i> Innova Crysta on Rent in Mumbai</Link></li>
<li><Link to="/Ertiga-On-Rent-in-Mumbai"><i className="fas fa-plane-departure darkcolor"></i> Ertiga On Rent in Mumbai</Link></li>
<li><Link to="/Sedan-Cab-Service-Mumbai"><i className="fas fa-plane-departure darkcolor"></i> Sedan Cab Service Mumbai</Link></li>
<li><Link to="/Tempo-Traveller-On-Rent-Mumbai"><i className="fas fa-plane-departure darkcolor"></i> Tempo Traveller On Rent Mumbai</Link></li>
<li><Link to="/Mini-Bus-on-Rent-in-Mumbai"><i className="fas fa-plane-departure darkcolor"></i> Mini Bus on Rent in Mumbai</Link></li>
<li><Link to="/Kia-Carens-Cab-Service-in-Mumbai"><i className="fas fa-plane-departure darkcolor"></i> Kia Carens Cab Service in Mumbai</Link></li>
<li><Link to="/Toyota-Etios-on-Rent-in-Mumbai"><i className="fas fa-plane-departure darkcolor"></i> Toyota Etios on Rent in Mumbai</Link></li>
<li><Link to="/Car-Rental-Mumbai"><i className="fas fa-plane-departure darkcolor"></i> Car Rental Mumbai</Link></li>
<li><Link to="/Explore-India-Pan-India-Cab-Booking-Services"><i className="fas fa-plane-departure darkcolor"></i> Explore India / Pan India Cab Booking Services</Link></li>
<li><Link to="/Mumbai-to-Pandharpur-Akkalkot-Tuljapur-Cab-Booking"><i className="fas fa-plane-departure darkcolor"></i> Mumbai to Pandharpur Akkalkot Tuljapur Cab Booking</Link></li>
<li><Link to="/Outstation-Taxi-Service-in-Mumbai"><i className="fas fa-plane-departure darkcolor"></i> Outstation Taxi Service in Mumbai</Link></li>
<li><Link to="/Car-Hire-for-Outstation-in-Mumbai"><i className="fas fa-plane-departure darkcolor"></i> Car Hire for Outstation in Mumbai</Link></li>
<li><Link to="/Mumbai-to-Hyderabad-Cabs"><i className="fas fa-plane-departure darkcolor"></i> Mumbai to Hyderabad Cabs</Link></li>
<li><Link to="/Mumbai-Cab-Service"><i className="fas fa-plane-departure darkcolor"></i> Mumbai Cab Service</Link></li>
<li><Link to="/Best-Cab-Service-in-Mumbai"><i className="fas fa-plane-departure darkcolor"></i> Best Cab Service in Mumbai</Link></li>
<li><Link to="/Mumbai-to-Ayodhya-Cab"><i className="fas fa-plane-departure darkcolor"></i> Mumbai to Ayodhya Cab</Link></li>
<li><Link to="/Mumbai-to-Saputara-Cabs"><i className="fas fa-plane-departure darkcolor"></i> Mumbai to Saputara Cabs</Link></li>
<li><Link to="/Mumbai-to-Bhopal-Cab"><i className="fas fa-plane-departure darkcolor"></i> Mumbai to Bhopal Cab</Link></li>
<li><Link to="/Mumbai-to-Telangana-Cab-Service"><i className="fas fa-plane-departure darkcolor"></i> Mumbai to Telangana Cab Service</Link></li>
<li><Link to="/Mumbai-to-Shani-Shingnapur-Cab"><i className="fas fa-plane-departure darkcolor"></i> Mumbai to Shani Shingnapur Cab</Link></li>
<li><Link to="/Mumbai-to-Trimbakeshwar-Cab"><i className="fas fa-plane-departure darkcolor"></i> Mumbai to Trimbakeshwar Cab</Link></li>
<li><Link to="/Mumbai-Airport-to-Vadodara-Cab"><i className="fas fa-plane-departure darkcolor"></i> Mumbai Airport to Vadodara Cab</Link></li>
<li><Link to="/Mumbai-to-Solapur-Cab"><i className="fas fa-plane-departure darkcolor"></i> Mumbai to Solapur Cab</Link></li>
<li><Link to="/Mumbai-to-Ratnagiri-Cab"><i className="fas fa-plane-departure darkcolor"></i> Mumbai to Ratnagiri Cab</Link></li>
<li><Link to="/Mumbai-to-Grishneshwar-Cab"><i className="fas fa-plane-departure darkcolor"></i> Mumbai to Grishneshwar Cab</Link></li>
<li><Link to="/Mumbai-to-Palghar-Cab"><i className="fas fa-plane-departure darkcolor"></i> Mumbai to Palghar Cab</Link></li>
<li><Link to="/Mumbai-to-Ujjain-Cab"><i className="fas fa-plane-departure darkcolor"></i> Mumbai to Ujjain Cab</Link></li>
<li><Link to="/Mumbai-to-Jaipur-Cab"><i className="fas fa-plane-departure darkcolor"></i> Mumbai to Jaipur Cab</Link></li>




              </ul>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="footer-widget footer-menu">
                    <h5 className="footer-title">Our Services</h5>
                    <ul>
                      <li><Link to="/Mumbai-to-Gujarat-Cab"><i className="fas fa-plane-departure darkcolor"></i> Mumbai to Gujarat Cab</Link></li>
                      <li><Link to="/Innova-On-Rent-Mumbai"><i className="fas fa-plane-departure darkcolor"></i> Innova On Rent Mumbai</Link></li>
                      <li><Link to="/Kia-Carens-On-Rent-in-Mumbai"><i className="fas fa-plane-departure darkcolor"></i> Kia Carens On Rent in Mumbai</Link></li>
<li><Link to="/Navi-Mumbai-Airport-Cab"><i className="fas fa-plane-departure darkcolor"></i> Navi Mumbai Airport Cab</Link></li>

<li><Link to="/Navi-Mumbai-Airport-Cab-Service"><i className="fas fa-plane-departure darkcolor"></i> Navi Mumbai Airport Cab Service</Link></li>

<li><Link to="/Navi-Mumbai-Airport-to-Pune-Cab"><i className="fas fa-plane-departure darkcolor"></i> Navi Mumbai Airport to Pune Cab</Link></li>
<li><Link to="/Navi-Mumbai-Airport-to-Nashik-Cab"><i className="fas fa-plane-departure darkcolor"></i> Navi Mumbai Airport to Nashik Cab</Link></li>
<li><Link to="/Online-Cab-Booking-Navi-Mumbai-Airport"><i className="fas fa-plane-departure darkcolor"></i> Online Cab Booking Navi Mumbai Airport</Link></li>
<li><Link to="/Navi-Mumbai-Airport-to-Lonavala-Cabs"><i className="fas fa-plane-departure darkcolor"></i> Navi Mumbai Airport to Lonavala Cabs</Link></li>
<li><Link to="/Mumbai-Airport-Cab-Service"><i className="fas fa-plane-departure darkcolor"></i> Mumbai Airport Cab Service</Link></li>
<li><Link to="/Navi-Mumbai-to-Mahabaleshwar-Cab"><i className="fas fa-plane-departure darkcolor"></i> Navi Mumbai to Mahabaleshwar Cab</Link></li>
<li><Link to="/Navi-Mumbai-to-Shirdi-Taxi-Fare"><i className="fas fa-plane-departure darkcolor"></i> Navi Mumbai to Shirdi Taxi Fare</Link></li>
<li><Link to="/Navi-Mumbai-Taxi-Service"><i className="fas fa-plane-departure darkcolor"></i> Navi Mumbai Taxi Service</Link></li>
<li><Link to="/Cheapest-Cab-Service-in-Mumbai"><i className="fas fa-plane-departure darkcolor"></i> Cheapest Cab Service in Mumbai</Link></li>
<li><Link to="/Navi-Mumbai-to-Kolhapur-Cab"><i className="fas fa-plane-departure darkcolor"></i> Navi Mumbai to Kolhapur Cab</Link></li>
<li><Link to="/Innova-Crysta-On-Rent-in-Navi-Mumbai"><i className="fas fa-plane-departure darkcolor"></i> Innova Crysta On Rent in Navi Mumbai</Link></li>
<li><Link to="/Ertiga-On-Rent-in-Navi-Mumbai"><i className="fas fa-plane-departure darkcolor"></i> Ertiga On Rent in Navi Mumbai</Link></li>
<li><Link to="/Swift-Dzire-on-Rent-in-Navi-Mumbai"><i className="fas fa-plane-departure darkcolor"></i> Swift Dzire on Rent in Navi Mumbai</Link></li>
<li><Link to="/Navi-Mumbai-Airport-to-Goa-Cabs"><i className="fas fa-plane-departure darkcolor"></i> Navi Mumbai Airport to Goa Cabs</Link></li>
<li><Link to="/Navi-Mumbai-International-Airport-Cab"><i className="fas fa-plane-departure darkcolor"></i> Navi Mumbai International Airport Cab</Link></li>
<li><Link to="/Navi-Mumbai-to-Ashtavinayak-Cab-Service"><i className="fas fa-plane-departure darkcolor"></i> Navi Mumbai to Ashtavinayak Cab Service</Link></li>
<li><Link to="/Navi-Mumbai-to-5-Jyotirlinga-Darshan-Cab"><i className="fas fa-plane-departure darkcolor"></i> Navi Mumbai to 5 Jyotirlinga Darshan Cab</Link></li>
<li><Link to="/Round-Trip-Cab-Navi-Mumbai"><i className="fas fa-plane-departure darkcolor"></i> Round Trip Cab Navi Mumbai</Link></li>
<li><Link to="/Outstation-Cab-Service-Navi-Mumbai"><i className="fas fa-plane-departure darkcolor"></i> Outstation Cab Service Navi Mumbai</Link></li>
<li><Link to="/Navi-Mumbai-to-Pune-Daily-Cab-Service"><i className="fas fa-plane-departure darkcolor"></i> Navi Mumbai to Pune Daily Cab Service</Link></li>
<li><Link to="/Navi-Mumbai-Corporate-Cab-Service"><i className="fas fa-plane-departure darkcolor"></i> Navi Mumbai Corporate Cab Service</Link></li>
{/* <li><Link to="/Navi-Mumbai-International-Airport-NMIA-Cabs"><i className="fas fa-plane-departure darkcolor"></i> Navi Mumbai International Airport (NMIA) Cabs</Link></li> */}
<li><Link to="/Mumbai-to-Nashik-Cab"><i className="fas fa-plane-departure darkcolor"></i> Mumbai to Nashik Cab</Link></li>
<li><Link to="/Mumbai-to-Khatu-Shyam-Cab"><i className="fas fa-plane-departure darkcolor"></i> Mumbai to Khatu Shyam Cab</Link></li>
<li><Link to="/Mumbai-to-Nagpur-Cab"><i className="fas fa-plane-departure darkcolor"></i> Mumbai to Nagpur Cab</Link></li>
<li><Link to="/Mumbai-to-Pimpri-Chinchwad-Cabs"><i className="fas fa-plane-departure darkcolor"></i> Mumbai to Pimpri Chinchwad Cabs</Link></li>
<li><Link to="/Navi-Mumbai-to-Goa-Cab-Service"><i className="fas fa-plane-departure darkcolor"></i> Navi Mumbai to Goa Cab Service</Link></li>
<li><Link to="/Mumbai-Airport-to-Goa-Cab"><i className="fas fa-plane-departure darkcolor"></i> Mumbai Airport to Goa Cab</Link></li>
<li><Link to="/Mumbai-to-Goa-One-Way-Cab"><i className="fas fa-plane-departure darkcolor"></i> Mumbai to Goa One Way Cab</Link></li>
<li><Link to="/Thane-to-Goa-Cabs"><i className="fas fa-plane-departure darkcolor"></i> Thane to Goa Cabs</Link></li>
<li><Link to="/Best-Mumbai-to-Goa-Cab-Service"><i className="fas fa-plane-departure darkcolor"></i> Best Mumbai to Goa Cab Service</Link></li>
<li><Link to="/Mumbai-to-Goa-Cab-Booking"><i className="fas fa-plane-departure darkcolor"></i> Mumbai to Goa Cab Booking</Link></li>
<li><Link to="/Kharghar-Taxi-Services"><i className="fas fa-plane-departure darkcolor"></i> Kharghar Taxi Services</Link></li>
<li><Link to="/Mumbai-Airport-Cabs"><i className="fas fa-plane-departure darkcolor"></i> Mumbai Airport Cabs</Link></li>
           </ul>
                
                
                
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

{/* ================= CONTACT DETAILS ================= */}

<div className="footer-contact-box mt-5">

  <div className="row g-4">

    {/* Phone */}
    <div className="col-lg-4 col-md-6">
      <div className="contact-card-footer">

        <div className="contact-icon">
          <i className="fas fa-phone-alt"></i>
        </div>

        <h5>Call Us</h5>

        <a href="tel:+919545731161">
          +91 9545731161
        </a>

    

      </div>
    </div>

    {/* Email */}

    <div className="col-lg-4 col-md-6">

      <div className="contact-card-footer">

        <div className="contact-icon">
          <i className="fas fa-envelope"></i>
        </div>

        <h5>Email Address</h5>

        <a href="mailto:booking@mumbaiairportcabs.com">
          booking@mumbaiairportcabs.com
        </a>

      </div>

    </div>

    {/* Address */}

    <div className="col-lg-4">

      <div className="contact-card-footer">

        <div className="contact-icon">
          <i className="fas fa-map-marker-alt"></i>
        </div>

        <h5>Office Address</h5>
<h6 className="text-white fw-dark">Mumbai Airport Cab</h6>
        <p>
          SAWANT SADAN 05 Ramachandra Cold Drinks House,
          Near SBI Bank, Nehru Road,
          Opp Noble Medical,
          Vile Parle East,
          Mumbai - 400057
        </p>

      </div>

    </div>

  </div>

  {/* Google Map */}

  <div className="footer-map mt-4">

    <iframe
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2713.5809698580592!2d73.9129627!3d18.5619102!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c15a81afc021%3A0x1381bafdd2f10fca!2sLMS%20Finswell!5e1!3m2!1sen!2sin!4v1781103094445!5m2!1sen!2sin"
      width="100%"
      height="300"
      style={{ border: 0 }}
      loading="lazy"
      allowFullScreen
      referrerPolicy="no-referrer-when-downgrade"
      title="Google Map"
    ></iframe>

  </div>

</div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container">
          <div className="copyright">
            <div className="row align-items-center row-gap-3 text-center">
              <div className="col-12">
                  <p className="copyright-text text-white">
              All Rights Reserved &copy;  <span className="darkcolorrr">Mumbai Airport Cabs</span> <span id="date">{new Date().getFullYear()}</span>{' '}
                <span href="#"> Developed By </span> <a href="https://www.dexterintelligence.com/" className='d-inline' target="_blank" rel="noopener noreferrer">
                <span className="darkcolorrr">&nbsp;Dexter Intelligence</span>
              </a> | Hosted By <a href="https://www.urvahosting.com/" className='d-inline ' target="_blank" rel="noopener noreferrer">
                <span className="darkcolorrr">&nbsp;Urva Hosting</span>
              </a>
              </p>
              </div>
              {/* <div className="col-lg-4">
                <div className="payment-list">
                  <a href="javascript:void(0);">
                    <img src="/images/icons/payment-01.svg" alt="img" />
                  </a>
                  <a href="javascript:void(0);">
                    <img src="/images/icons/payment-02.svg" alt="img" />
                  </a>
                  <a href="javascript:void(0);">
                    <img src="/images/icons/payment-03.svg" alt="img" />
                  </a>
                </div>
              </div> */}
              {/* <div className="col-lg-4">
                <ul className="privacy-link">
                  <li><a href="privacy-policy.html">Privacy</a></li>
                  <li><a href="terms-condition.html">Terms & Condition</a></li>
                  <li><a href="javascript:void(0);">Refund Policy</a></li>
                </ul>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;


